module.exports = __webpack_public_path__ + "img/53.01ab07e4.png";